import { toast } from "react-toastify";

type Props = {
  inputValue: any;
  setErrors: (value: any) => void;
};

export const validateforUserData = ({ inputValue, setErrors }: Props) => {
  let isFormValid: any = true;
  const errors: any = {};

  if (
    !inputValue?.surveyQuestion?.trim() ||
    inputValue?.surveyQuestion === "" ||
    inputValue?.surveyQuestion === undefined
  ) {
    isFormValid = false;
    errors["surveyQuestion"] = "*Please enter survey question";
  }

  if (inputValue?.surveyType === "" || inputValue?.surveyType === undefined) {
    isFormValid = false;
    errors["surveyType"] = "*Bitte wählen Sie den Umfragetyp aus";
  }

  if (
    !inputValue?.surveyQuestion_ger?.trim() ||
    inputValue?.surveyQuestion_ger === "" ||
    inputValue?.surveyQuestion_ger === undefined
  ) {
    isFormValid = false;
    errors["surveyQuestion_ger"] = "*Bitte geben Sie den Namen ein";
  }

  if (inputValue?.surveyField === "" || inputValue?.surveyField === undefined) {
    isFormValid = false;
    errors["surveyField"] = "*Bitte Umfrage auswählen";
  }

  if (inputValue?.coin === "" || inputValue?.coin === undefined) {
    isFormValid = false;
    errors["coin"] = "*Bitte geben Sie die Punktzahl ein";
  }

  setErrors(errors);
  return isFormValid;
};
